import { rangePresets } from '@gogame/intl-ts';

export const CREATION_PERIOD_PRESETS = [
  rangePresets.THIS_MONTH,
  rangePresets.THIS_MONTH_MINUS_1,
  rangePresets.LAST_MONTH,
  rangePresets.LAST_30_DAYS,
  rangePresets.TODAY,
  rangePresets.YESTERDAY,
  rangePresets.THIS_WEEK,
  rangePresets.LAST_7_DAYS,
  rangePresets.LAST_10_DAYS,
  rangePresets.LAST_3_DAYS,
  rangePresets.LAST_90_DAYS,
  rangePresets.THIS_YEAR,
  rangePresets.LAST_12_MONTHS,
  rangePresets.LAST_YEAR,
  rangePresets.LIFETIME,
];
